// src/lib/observability.js
// Lightweight error monitoring (Batch 6). Vendor-agnostic: if a DSN/endpoint
// is configured (VITE_ERROR_ENDPOINT), unhandled errors POST there; otherwise
// they go to console only. Keeps the app from ever "flying blind" without
// coupling to a specific vendor before the account exists.
/* global __BUILD_ID__ */
const ENDPOINT = import.meta.env.VITE_ERROR_ENDPOINT || null;
const BUILD = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";

// Reports one error event to the configured sink (best-effort, never throws)
function report(kind, detail) {
  try {
    const evt = {
      kind,
      detail: String(detail).slice(0, 1000),
      build: BUILD,
      url: location.hash,
      ua: navigator.userAgent,
      at: new Date().toISOString(),
    };
    if (ENDPOINT) {
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(evt),
        keepalive: true,
      }).catch(() => {});
    } else {
      console.warn("[observability]", kind, detail);
    }
  } catch {
    /* observability must never break the app */
  }
}

// Installs global error + promise-rejection handlers. Call once at boot.
export function initObservability() {
  window.addEventListener("error", (e) =>
    report("error", e.message || e.error),
  );
  window.addEventListener("unhandledrejection", (e) =>
    report("unhandledrejection", e.reason?.message || e.reason),
  );
}
